












import { Component, Vue, Prop } from 'vue-property-decorator'
import DownloadBase from '../../modules/class/Downloads'
import { createCustomEvent } from '../../modules/CustomEvent'

@Component
export default class DownloadLink extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // props
  @Prop() private downloadfileinfo!: DownloadBase

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * url click aタグ
   * @click.preventのためaタグのリロードを抑制
   */
  public async clickLink(info: DownloadBase): Promise<void> {
    createCustomEvent('start-pdf-download', { url: info.url })
  }
}
